import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, Snackbar, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { grey, red } from '@mui/material/colors';

import BASE_URL from '../../config'

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 400, bgcolor: 'white', borderRadius: 4, p: 4, outline: 'none', textAlign: 'center'
};

export default function DeletePop({ agenda, refresh }) {
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  const handleDelete = async () => {
    try {
      const res = await fetch(`${BASE_URL}/agendas/${agenda.id}`, {
        method: 'DELETE',
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setOpen(false);
        refresh();
      } else {
        setSnackbar({ open: true, message: data.message || data.error || 'No se pudo eliminar la cita', severity: 'error' });
      }
    } catch (e) {
      setSnackbar({ open: true, message: 'Error de conexión con el servidor', severity: 'error' });
    }
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}
      sx={{'&:hover': {color:grey[100], bgcolor: red[400] } }}>
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" textAlign={'left'} mb={1}>{`¿Eliminar la cita del cliente ${agenda.nombre_cliente}?`}</Typography>
          <Typography variant="body1" color='textSecondary' mb={2} textAlign={'left'}>
            Esta acción no se puede deshacer.¿Estás seguro que deseas eliminar este cliente permanentemente?.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 ,justifyContent:'right'}}>
            <Button fullWidth variant="contained" 
                    sx={{ color: 'black', bgcolor:grey[100], textTransform: 'none',width: { xs: '50%', sm: '38%' } }} 
                    onClick={() => setOpen(false)}>
              No, cancelar
            </Button>
            <Button fullWidth variant="contained" 
                    sx={{ bgcolor: red[400], '&:hover': { bgcolor: red[600] }, textTransform: 'none',width: { xs: '50%', sm: '38%' } }} 
                    onClick={handleDelete}>
              Sí, eliminar
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}